import React from "react";
import clsx from "clsx";
import DateHelper from "../../DateHelper/DateHelper";
import { format, parseISO } from "date-fns";
import Switch from "../../Switch/Switch"


export default class FeePresenterGeneral extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var unit;
    if (this.props.tax_fee_unit) {
      // console.log("this.props.tax_fee_unit", this.props.tax_fee_unit);

      if (this.props.tax_fee_unit.ru_id == "1") {
        unit = "room_per_stay"
      } else if (this.props.tax_fee_unit.ru_id == "2") {
        unit = "room_per_day"
      } else if (this.props.tax_fee_unit.ru_id == "5") {
        unit = "guest_per_stay"
      } else if (this.props.tax_fee_unit.ru_id == "6") {
        unit = "guest_per_day"
      } else {
        unit = null
      }
    } else {
      unit = null
    }

    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses}>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t("code")}*`}</label>
              <div>{this.props.code}</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t("name")}*`}</label>
              <div>{this.props.name}</div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("type")}</label>
              <div>
                {this.props.tax_fee_type
                  ? this.props.tax_fee_type.name
                  : I18n.t("none")}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("status")}</label>
              <div>{I18n.t(this.props.status)}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>
                {`${I18n.t("begins")}*`}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("season_start_date_helper_text")}
                ></span>
              </label>
              <div>
                {format(
                  parseISO(this.props.start_date),
                  DateHelper.rubyToDateFNS(this.props.date_format)
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>
                {`${I18n.t("ends")}`}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("season_end_date_helper_text")}
                ></span>
              </label>
              {this.props.end_date ? (
                <div>
                  {format(
                    parseISO(this.props.end_date),
                    DateHelper.rubyToDateFNS(this.props.date_format)
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <br />
        <div className="container card">
          <div className="row">
            <div className="col-sm-2">
              <div className="form-group">
                <label>{I18n.t("rate")}</label>
                <div className="form-control">
                  {parseFloat((this.props.percentage * 100).toFixed(2))}%
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="row content-center">
                <em className="form-descriptor">{I18n.t("or")}</em>
              </div>
            </div>
            <div className="col-sm-7 card amount-unit-card">
              <div className="row">
                <div className="col-sm-4 amount-unit-wrapper">
                  <div className="form-group">
                    <label>
                      {I18n.t("amount")}{" "}
                      <span
                        className="ss-help help"
                        title={I18n.t("taxes_amount_helper_text")}
                      ></span>
                    </label>
                    <div>
                      {" "}
                      <span>{I18n.t("number.currency.format.unit")}</span>
                      {(this.props.amount / 100).toFixed(2)}
                    </div>
                  </div>
                </div>
                <div className="col-sm-2">
                  <div className="row content-center">
                    <em className="form-descriptor">{I18n.t("per")}</em>
                  </div>
                </div>
                <div className="col-sm-4 amount-unit-wrapper">
                  <label>
                    {I18n.t("unit")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("taxes_unit_helper_text")}
                    ></span>
                  </label>
                  <div>{unit ? I18n.t(unit) : null}</div>
                </div>
              </div>


              {
                unit == "guest_per_stay" && !this.props.tax || unit == "guest_per_day" && !this.props.tax
                  ?
                <div className="row">

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>{I18n.t('guests_included')}</label>
                      <div>{this.props.guests_included}</div>
                      {/* <NumberSpinner
                      
                        onChange={this.props.onChange}
                        name='guests_included'
                        min={0}
                        value={this.props.guests_included || ''}
                        hasError={this.renderFieldClasses('guests_included')}  /> */}
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="row content-center">
                      <em className="form-descriptor"></em>
                    </div>
                  </div>
                  {
                    !this.props.tax
                      ?
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>{I18n.t('calculate_by_guest_type')} <span
                            className="ss-help help"
                            title={I18n.t("calculate_by_guest_type_helper_text")}>
                          </span>
                        </label>
                        <Switch 
                          disabled={true}
                          onText="yes" 
                          offText="no" 
                          // onChange={this.props.onChangeCalculateByGuestType} 
                          value={this.props.calculate_by_guest_type} 
                          switchId="calculate_by_guest_type"
                        />
                      </div>
                    </div>
                      : 
                    null
                  }
                
                </div>
                  :
                null
              }


            </div>
          </div>
        </div>
      </div>
    );
  }
}
